import store from '@/store'
import { SET_CLIENT_VERSION } from '@/store/mutations'
import { bakedClientVersion } from '@/store/state'
import { createVersionGuard, fetchDeployedVersion } from '@/deployment-version'

export const versionGuard = createVersionGuard({
  bakedVersion: bakedClientVersion,
  fetchDeployedVersion: () => fetchDeployedVersion(),
  reload: (path) => {
    window.location = path
  },
  storage: window.sessionStorage,
  onNewVersion: (version) => store.commit(SET_CLIENT_VERSION, version),
})
